import React, { PureComponent } from 'react';

import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Row, Col } from 'react-bootstrap';
import SelectNazione from '../RegistrationForm/SelectNazione';
import SelectTipoDocumento from '../RegistrationForm/SelectTipoDocumento';

import bsCustomFileInput from 'bs-custom-file-input';
import CzGlobals from '../global';

import Labels_en from '../labels_en';
import Labels_it from '../labels_it';

import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamation } from '@fortawesome/free-solid-svg-icons'


class RegistrationPage3 extends PureComponent {

  Labels = null;

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      tipo_documento: null,
      numero_documento: null, 
      fldUploadFileFronte: null
    };

    if (props.lang == "it") {
      this.Labels = Labels_it;
    } else {
      this.Labels = Labels_en;
    }

    




    this.handleSubmitPassaporto = (e) => {

      e.preventDefault();


      const upload_file_fronte = this.state.fldUploadFileFronte;

      const formData = new FormData();

      var dati = {
        tipo_documento: this.state.tipo_documento,
        numero_documento: this.state.numero_documento
      };
      var s = btoa(JSON.stringify(dati));


      formData.append('d', s);
      formData.append('file_fronte', upload_file_fronte);

      const request = axios.post(CzGlobals.apisite + 'AJAXUpload.php', formData)
        .then(function (response) {
          var res = response.data;
          if (res.status=="OK") {
          
          
          
          }

        });

      return 1;

    }

    
    this.fetchAllData = () => {

      const request = axios.get(CzGlobals.apisite + 'JSONDocumenti.php')
      .then(function (response) {
       //   alert(response);
      });

    }
      

  }

  componentWillMount = () => {
    console.log('RegistrationPage1 will mount');
  }

  componentDidMount = () => {
    bsCustomFileInput.init();
    this.fetchAllData();
    console.log('RegistrationPage1 mounted');
  }

  componentWillReceiveProps = (nextProps) => {
    console.log('RegistrationPage1 will receive props', nextProps);
  }

  componentWillUpdate = (nextProps, nextState) => {
    console.log('RegistrationPage1 will update', nextProps, nextState);
  }

  componentDidUpdate = () => {
    console.log('RegistrationPage1 did update');
  }

  componentWillUnmount = () => {
    console.log('RegistrationPage1 will unmount');
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return (
      <div className="RegistrationPage1Wrapper">
        <Card>
          <Card.Body>



            <Form onSubmit={this.handleSubmitPassaporto} >

              <Form.Row>
                <Form.Group as={Col} xs="5" lg="3">
                  <Form.Label><b>{this.Labels.lbl_DocumentoIdentita}</b></Form.Label>
                  <SelectTipoDocumento onChange={e => this.setState({ tipo_documento: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} xs="6" lg="4">
                  <Form.Label><b>{this.Labels.lbl_DocumentoIdentitaNazione}</b></Form.Label>
                  <SelectNazione />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} xs="4" lg="2">
                  <Form.Label><b>{this.Labels.lbl_DocumentoIdentitaNumero}</b></Form.Label>
                  <Form.Control placeholder="" onChange={e => this.setState({ numero_documento: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} xs="4" lg="2">
                  <Form.Label><b>{this.Labels.lbl_DocumentoIdentitaData}</b></Form.Label>
                  <Form.Control type="date" placeholder="" />
                </Form.Group>
                <Form.Group as={Col} xs="4" lg="2">
                  <Form.Label><b>{this.Labels.lbl_DocumentoIdentitaScadenza}</b></Form.Label>
                  <Form.Control type="date" placeholder="" />
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} xs="6" controlId="formGridName">
                  <FontAwesomeIcon icon={faExclamation} color="red"/>
                  <Form.Label><b>{this.Labels.lbl_DocumentoIdentitaFronte}</b></Form.Label>
                  <Form.File
                    label=""
                    custom
                    onChange={e => this.setState({ fldUploadFileFronte: e.target.files[0] })}
                  />
                </Form.Group>
               

              </Form.Row>



              <Button variant="primary" type="submit">
                Submit
            </Button>

            </Form>

          </Card.Body>
        </Card>
      </div >
    );
  }
}

RegistrationPage3.propTypes = {
  // bla: PropTypes.string,
};

RegistrationPage3.defaultProps = {
  // bla: 'test',
};

export default RegistrationPage3;
